import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { LogOut, User, Shield, Building2, LayoutDashboard } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom'; // Importar Link

import i18next from 'i18next';

const Header = () => {
  const { t, i18n } = useTranslation();
  const { user, logout, isAdmin } = useAuth();
  const [showMenu, setShowMenu] = React.useState(false);
  // Buscar carta operativa en los usuarios demo
  const cartaOperativa = (() => {
    if (!user) return null;
    const usuariosDemo = [
      { email: 'admin@empresa.com', file: { name: 'CartaOperativa-Admin.pdf', url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf' } },
      { email: 'agencia@marketing.com', file: { name: 'CartaOperativa-Agencia.pdf', url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf' } },
      { email: 'distribuidor@ventas.com', file: { name: 'CartaOperativa-Distribuidor.pdf', url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf' } }
    ];
    return usuariosDemo.find(u => u.email === user.email)?.file || null;
  })();
  const navigate = require('react-router-dom').useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  // Estado para mostrar el avatar ampliado
  const [showAvatar, setShowAvatar] = React.useState(false);

  return (
    <>
      <motion.header
        className="bg-white/95 backdrop-blur-lg border-b border-gray-200/50 sticky top-0 z-50"
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8 relative">
        {/* Selector de idioma visual perfectamente centrado */}
        <div className="absolute left-1/2 top-2 -translate-x-1/2 z-20 flex gap-1 sm:gap-2 items-center justify-center">
          {/* ... Selector de banderas igual ... */}
          <button type="button" aria-label="Español" onClick={() => i18n.changeLanguage('es')} className={`p-0.5 rounded-full border-2 transition-all ${i18n.language === 'es' ? 'border-blue-500' : 'border-transparent'}`} style={{ width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'white' }}><img src="/flags/es.svg" alt="Español" style={{ width: 20, height: 20, borderRadius: '50%' }} /></button>
          <button type="button" aria-label="English" onClick={() => i18n.changeLanguage('en')} className={`p-0.5 rounded-full border-2 transition-all ${i18n.language === 'en' ? 'border-blue-500' : 'border-transparent'}`} style={{ width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'white' }}><img src="/flags/en.svg" alt="English" style={{ width: 20, height: 20, borderRadius: '50%' }} /></button>
          <button type="button" aria-label="Português" onClick={() => i18n.changeLanguage('pt')} className={`p-0.5 rounded-full border-2 transition-all ${i18n.language === 'pt' ? 'border-blue-500' : 'border-transparent'}`} style={{ width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'white' }}><img src="/flags/pt.svg" alt="Português" style={{ width: 20, height: 20, borderRadius: '50%' }} /></button>
        </div>
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center h-auto sm:h-16 gap-2 sm:gap-0 pt-10 sm:pt-0">
          <Link to="/" className="flex items-center gap-2 sm:gap-3 justify-center sm:justify-start">
            <motion.div className="flex items-center gap-2 sm:gap-3" whileHover={{ scale: 1.02 }}>
              <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl flex items-center justify-center">
                <Building2 className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
              </div>
              <div>
                <h1 className="text-base sm:text-xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent">
                  {t('welcome')}
                </h1>
                <p className="text-xs text-gray-500 hidden sm:block">Plataforma de Turismo y Hotelería</p>
              </div>
            </motion.div>
          </Link>
          <div className="flex flex-col xs:flex-row items-center gap-2 sm:gap-4">
            <div className="flex flex-row items-center gap-2 sm:gap-4">
              {isAdmin && (
                <Link to="/admin">
                  <motion.button
                    title="Panel Admin"
                    className="flex items-center gap-1 sm:gap-2 px-2 sm:px-4 py-1 sm:py-2 bg-blue-50 hover:bg-blue-100 text-blue-700 rounded-xl font-semibold text-xs sm:text-base transition-colors"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <LayoutDashboard className="w-4 h-4" />
                    <span className="hidden xs:inline">Admin</span>
                  </motion.button>
                </Link>
              )}
              <div className="flex items-center gap-2 sm:gap-3 px-2 sm:px-4 py-1 sm:py-2 bg-gray-50 rounded-xl">
                {/* Avatar del usuario con hover/click para ampliar */}
                {user?.avatar && (
                  <div className="relative">
                    <img
                      src={user.avatar}
                      alt="Avatar"
                      className="w-8 h-8 rounded-full object-cover border cursor-pointer"
                      onMouseEnter={() => setShowAvatar(true)}
                      onMouseLeave={() => setShowAvatar(false)}
                    />
                    {showAvatar && (
                      <div
                        className="absolute left-1/2 -translate-x-1/2 mt-2 bg-white rounded-2xl shadow-xl border border-gray-200 p-2 z-50"
                        onMouseEnter={() => setShowAvatar(true)}
                        onMouseLeave={() => setShowAvatar(false)}
                        style={{ minWidth: '170px' }}
                      >
                        <img src={user.avatar} alt="Avatar grande" className="w-44 h-44 rounded-2xl object-cover" />
                      </div>
                    )}
                  </div>
                )}
                <div className="text-xs sm:text-sm flex flex-col items-start">
                  <div className="relative">
                    <p
                      className="font-semibold text-gray-900 truncate max-w-[80px] sm:max-w-none cursor-pointer"
                      onClick={() => setShowMenu((v) => !v)}
                    >
                      {user?.name}
                    </p>
                    {showMenu && (
                      <div className="absolute left-1/2 -translate-x-1/2 mt-2 bg-white rounded-xl shadow-lg border border-gray-200 p-4 z-50 min-w-[200px] flex flex-col items-center">
                        <p className="font-bold text-gray-800 mb-2">Mi Perfil</p>
                        <p className="text-sm text-gray-600 mb-2">{user?.email}</p>
                        {cartaOperativa ? (
                          <a
                            href={cartaOperativa.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg font-semibold shadow hover:bg-blue-700 transition mb-2"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M12 16v-8m0 8l-4-4m4 4l4-4m-8 8h8a2 2 0 002-2V6a2 2 0 00-2-2H8a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                            Carta Operativa
                          </a>
                        ) : (
                          <span className="text-gray-400 mb-2">Sin carta operativa</span>
                        )}
                        <button
                          className="text-xs text-gray-500 hover:text-blue-600 mt-2"
                          onClick={() => setShowMenu(false)}
                        >Cerrar</button>
                      </div>
                    )}
                  </div>
                  <p className="text-gray-500 capitalize hidden xs:block">{user?.role === 'admin' ? 'Administrador' : 'Agente de Viajes'}</p>
                </div>
                <motion.button
                  onClick={handleLogout}
                  title={t('logout')}
                  className="ml-2 p-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all duration-200 flex items-center justify-center"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <LogOut className="w-5 h-5" />
                </motion.button>
              </div>
            </div>
          </div>
        </div>
      </div>
      </motion.header>
    </>
  );
}

export default Header;